import React from 'react'

const NoRecord = () => {
  return (
    <h4 className='text-center pt-4 ct_fs_20 ct_fw_600 ct_text_op_05'>
      No record found.
    </h4>
  )
}

export default NoRecord
